export default __webpack_public_path__ + "static/media/p2-3.24754c52.png";